import { useState, useEffect } from "react";
import API from "utils/api";

export default function useLikes(type, id, page = 0, limit = 6) {
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchLikes() {
      setLoading(true);

      const { response, data } = await API.fetchLikes(type, id, { page, limit });

      if (response.ok) {
        setResult(data);
        setLoading(false);
      } else {
        console.error(data);
      }
    }

    fetchLikes();
  }, [type, id, page, limit, setLoading, setResult]);

  return {
    loading,
    likes: result?.results ?? [],
    count: result?.count ?? 0,
    limit: result?.limit ?? 0,
    page: result?.page ?? 0,
  };
}
